import { useEffect, useState } from "react";
import { loadSpeller, findMisspelledRanges } from "./spellCheck";

const DEBOUNCE_MS = 500;

export default function useSpellCheck(text, enabled) {
  const [speller, setSpeller] = useState(null);
  const [ranges, setRanges] = useState([]);

  useEffect(() => {
    if (!enabled || speller) return undefined;

    let cancelled = false;
    loadSpeller()
      .then((loaded) => {
        if (!cancelled) setSpeller(loaded);
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, [enabled, speller]);

  useEffect(() => {
    if (!enabled || !speller) {
      setRanges([]);
      return undefined;
    }

    const timeoutId = setTimeout(() => {
      setRanges(findMisspelledRanges(speller, text));
    }, DEBOUNCE_MS);

    return () => clearTimeout(timeoutId);
  }, [text, speller, enabled]);

  return ranges;
}
